var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2568 7.875L10.6457 5.34133H8.21453V3.69715C8.21453 3.00398 8.55414 2.32832 9.64297 2.32832H10.7482V0.171172C10.7482 0.171172 9.74523 0 8.78629 0C6.78418 0 5.47551 1.21352 5.47551 3.41031V5.34133H3.25V7.875H5.47551V14H8.21453V7.875H10.2568Z",
    fill: "#EBE9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookF);
export default __webpack_public_path__ + "static/media/facebook-f.a7b17e5acc6e4e5eb38a8844b35eb863.svg";
export { ForwardRef as ReactComponent };